export default {
  menu: {
    about: "关于",
    getStarted: "Get Started",
    docs: "文档",
    gitHub: "GitHub",
  },
  about: {
    title: "StarryGL是什么？",
    content:
      "\nStarryGL是一个大规模分布式时序图神经网络学习框架，支持训练静态图神经网络、连续时间动态图神经网络和离散时间动态图神经网络等各种图神经网络模型。StarryGL提供了一系列一站式的功能组件，包括图划分、图存储、图采样、特征缓存、模型训练和内存更新同步等。与现有时序图神经网络训练框架工作对比，StarryGL的训练效率最优，训练效率提升0.73倍~6.98倍，同时保持相当的准确性。",
    content2:
      "\nStarryGL优异的性能来源于多权值负载均衡的图划分、高效可拓展并行采样算子、分布式高效读写子图特征缓存和分布式并行训练等多个模块的优化设计，从而实现了高效和可扩展的时序图神经网络训练。这些优化的效果包含：\n    - 时序图采样耗时减少24%～40%；\n    - 时序图采样吞吐量提升1.41～2.47倍；\n    - 分布式GPU读写链路的数据准备性能提升2倍数据写回性能提升1.5倍；\n    - 分布式图神经网络邻居聚合性能提升3～5倍。\n\n请参阅Get Started下载和使用StarryGL。更多详细介绍，请查阅公开文档。",
  },
  home: {
    title: "Starry Graph Learning",
    introduction:
      "StarryGL是一个大规模分布式时序图神经网络学习框架，支持高效和可扩展的时序图神经网络训练。",
    efficientTitle: "一站式图学习系统",
    efficientContent:
      "一个综合的时序图学习系统，包括图分区、存储、采样、特征缓存、模型训练和内存更新同步等组件。",
    temporalTitle: "通用时序图支持",
    temporalContent:
      "支持各种图学习模型，包括静态图神经网络、连续时间动态图神经网络和离散时间动态图神经网络。",
    leaderTitle: "高效可扩展",
    leaderContent:
      "支持在分布式集群中实现大规模图的高效可扩展时序图学习，训练效率提升超过1.2倍，同时保持相当的准确性。",
  },
  foot: {
    doc: {
      title: "资料",
      item1: "源码",
      item2: "数据集下载",
    },
    contact: {
      title: "联系我们",
    },
    un: "上海浙江大学高等研究院",
    no1: "沪公网安备 31011502019924号",
    no2: "沪ICP备2021025709号-3",
  },
};
